import * as Msal from 'msal'
import store from '../store'

const msalConfig = {
  auth: {
      clientId: "611a41f8-a88a-40a1-8fc5-960de0372fc1",
      authority: "https://login.microsoftonline.com/18b57840-82b9-46d4-85eb-e41a98ce9729"
  },
  cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: true
  }
};

const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};

// create a request object for login or token request calls
// In scenarios with incremental consent, the request object can be further customized
const requestObj = {
    scopes: ["611a41f8-a88a-40a1-8fc5-960de0372fc1"]
};

const myMSALObj = new Msal.UserAgentApplication(msalConfig);

// Register Callbacks for redirect flow
// myMSALObj.handleRedirectCallbacks(acquireTokenRedirectCallBack, acquireTokenErrorRedirectCallBack);
myMSALObj.handleRedirectCallback(authRedirectCallBack);

function signIn() {
    myMSALObj.loginPopup(requestObj).then(function () {
        //Successful login
        // showWelcomeMessage();
        //Call MS Graph using the token in the response
        acquireTokenPopupAndCallMSGraph();
    }).catch(function (error) {
        //Please check the console for errors
        console.log(error);
    });
}

function signOut() {
    myMSALObj.logout();
}

function acquireTokenPopupAndCallMSGraph() {
    //Always start with acquireTokenSilent to obtain a token in the signed in user from cache
    return myMSALObj.acquireTokenSilent(requestObj).then(function (tokenResponse) {
        // console.log(tokenResponse);
        store.commit('setTokenId', tokenResponse.idToken.rawIdToken);
        // callMSGraph(graphConfig.graphMeEndpoint, tokenResponse.accessToken, graphAPICallback);
        // callMSGraph('https://us-central1-discontract-stage.cloudfunctions.net/adminApi', tokenResponse.idToken.rawIdToken, (response) => {
          // document.getElementById('json').innerHTML = JSON.stringify(response).replace(/{/g, '{\n').replace('/}/g', '}\n');
          // console.log(response);
        // });
    }).catch(function (error) {
        console.log(error);
        signIn();
        // Upon acquireTokenSilent failure (due to consent or interaction or login required ONLY)
        // Call acquireTokenPopup(popup window) 
        // if (requiresInteraction(error.errorCode)) {
        //     myMSALObj.acquireTokenPopup(requestObj).then(function (tokenResponse) {
        //         callMSGraph(graphConfig.graphMeEndpoint, tokenResponse.accessToken, graphAPICallback);
        //     }).catch(function (error) {
        //         console.log(error);
        //     });
        // }
    });
}

function callMSGraph(theUrl, accessToken, callback) {
  // console.log(accessToken);
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200)
            callback(JSON.parse(this.responseText));
    }
    xmlHttp.open("GET", theUrl, true); // true for asynchronous
    xmlHttp.setRequestHeader('Authorization', 'Bearer ' + accessToken);
    xmlHttp.send();
}

function graphAPICallback() {
    //document.getElementById("json").innerHTML = JSON.stringify(data, null, 2);
}

function authRedirectCallBack(error, response) {
    if (error) {
        console.log(error);
    } else {
        if (response.tokenType === "access_token") {
            callMSGraph(graphConfig.graphMeEndpoint, response.accessToken, graphAPICallback);
        } else {
            console.log("token type is:" + response.tokenType);
        }
    }
}

// function requiresInteraction(errorCode) {
//     if (!errorCode || !errorCode.length) {
//         return false;
//     }
//     return errorCode === "consent_required" ||
//         errorCode === "interaction_required" ||
//         errorCode === "login_required";
// }

// runs on page load, change config to try different login types to see what is best for your application
if (myMSALObj.getAccount()) {// avoid duplicate code execution on page load in case of iframe and popup window.
    acquireTokenPopupAndCallMSGraph();
}

export default {
  refreshToken: acquireTokenPopupAndCallMSGraph,
  signIn,
  signOut
}
